import { render, staticRenderFns } from "./enterprise-total.vue?vue&type=template&id=2f8b4065&scoped=true&"
import script from "./enterprise-total.vue?vue&type=script&lang=js&"
export * from "./enterprise-total.vue?vue&type=script&lang=js&"
import style0 from "./enterprise-total.vue?vue&type=style&index=0&id=2f8b4065&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b4065",
  null
  
)

export default component.exports